import {Component, inject, Input, OnInit} from '@angular/core';
import {ConceptsContainer} from '../../../core/definitions/concepts-container';
import {CmsApiService} from '../../../core/cms-api.service';
import {ConceptSetting} from '../../../core/definitions/concept-setting';
import {UserCacheService} from "../../../core/user-cache.service";

@Component({
    selector: 'app-admin-list-settings',
    templateUrl: './admin-list-settings.component.html',
    styleUrls: ['./admin-list-settings.component.scss'],
    standalone: false
})
export class AdminListSettingsComponent implements OnInit {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly userCacheService: UserCacheService = inject(UserCacheService);

  @Input() conceptsContainer: ConceptsContainer;

  conceptSetting: ConceptSetting;

  ngOnInit(): void {
    this.setConceptSetting().then();
  }

  async store() {
    await this.cms.putSettingConcept(this.conceptSetting);
  }

  private async setConceptSetting() {
    const userData = await this.userCacheService.getUserData()
    if (userData.rights_level.toLowerCase() === 'admin') {
      this.conceptSetting = await this.cms.getSettingConcept(this.conceptsContainer.conceptType.concept_type_id);
    }
  }
}
